import { Path, Svg } from '@react-pdf/renderer';

export const PersonIcon = ({color}: {color: string}) => {
    return (
        <Svg width="17px" height="17px" viewBox="0 0 24 24" debug={false} style={{marginTop: '4px', marginBottom: '4px'}}>
      <Path
        d="M12,12 C14.21,12 16,10.21 16,8 C16,5.79 14.21,4 12,4 C9.79,4 8,5.79 8,8 C8,10.21 9.79,12 12,12 Z M12,14 C9.33,14 4,15.34 4,18 L4,19 C4,19.55 4.45,20 5,20 L19,20 C19.55,20 20,19.55 20,19 L20,18 C20,15.34 14.67,14 12,14 Z"
        fill={color}
      />
    </Svg>
    )
}

